( function() {
	var selects = document.getElementsByClassName('gfield_select');
	if ( ! selects.length ) {
		return;
	}
	
	var forEach = function (arr, callback) {
		Array.prototype.forEach.call(arr, callback);
	};
	
	forEach(selects, function (select) {
		function togglePlaceholderClass() {
			if (select.value == '') {
				select.classList.add('gfield_select--placeholder'); 
			} else {
				select.classList.remove('gfield_select--placeholder');
			}
		}
		
		togglePlaceholderClass();
		select.addEventListener('change', togglePlaceholderClass, true);
	});
} )();